import { SkillType, UserSkill } from '@borg/types';

type CreateSkill = Omit<UserSkill & { type?: SkillType }, 'id'>;

const BASE_URL = '/me/skills';

class SkillsRepository extends Repository<UserSkill> {
  getMany(type: SkillType) {
    return this._getMany({ url: `${BASE_URL}?type=${type}` });
  }

  get(id: string) {
    return this._get({ url: `${BASE_URL}/${id}` });
  }

  save(data: UserSkill) {
    return this._save({ url: `${BASE_URL}/${data.id}`, data });
  }

  create(data: CreateSkill) {
    return this._create({ url: BASE_URL, data });
  }

  delete(id: number | string) {
    return this._delete({ url: `${BASE_URL}/${id}` });
  }
}

export const skillsRepository = new SkillsRepository();
